import React from 'react';
import PropTypes from 'prop-types';
import AIcon from '../atoms/_atoms.icon';

export default class ADropDown extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value || this.props.placeholder || '',
			items: props.items || [],
			isEditing: false,
		};

		this.binHandles();
	}

	componentWillReceiveProps(props) {
		if (props.items !== this.state.items) {
			this.setState({ items: props.value });
		}

		if (props.value !== this.state.value) {
			this.setState({ value: props.value });
		}
	}

	binHandles() {
		this.handleToggle = this.handleToggle.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);
		this.handleKeyUpToggle = this.handleKeyUpToggle.bind(this);
	}

	toggleState() {
		this.setState({ isEditing: !this.state.isEditing });
	}

	handleSelect(option) {
		if (this.state.isEditing) {
			this.setState({ value: option.value });
		}

		if (this.props.onSelect) {
			this.props.onSelect({ ...this.state, value: option });
		}

		this.toggleState();
	}

	handleKeyUp(event, option) {
		if (event.keyCode !== 13) {
			return;
		}

		this.handleSelect(option);
	}

	handleToggle() {
		if (!this.state.isEditing && this.props.onChange) {
			this.props.onChange({ ...this.state, isEditing: true });
		}

		this.toggleState();
	}

	handleKeyUpToggle(event) {
		if (event.keyCode === 13) {
			this.handleToggle();
		}
	}

	render() {
		let dropDown;
		const headerClass = this.state.isEditing ? "drop-down--header active" : "drop-down--header";

		if (this.state.isEditing) {
			dropDown = (
				<ul className="drop-down--body">
					{
						this.props.items.map((option) => {
							return (
								<li
									role="button"
									tabIndex="0"
									key={option.id}
									className="a-list-row drop-down--row"
									option={option.value}
									onClick={() => this.handleSelect(option)}
									onKeyUp={event => this.handleKeyUp(event, option)}
								>
									{option.value}
								</li>);
						})
					}
				</ul>
			);
		}

		return (
			<section
				id={this.props.id}
				className={`a-drop-down ${this.props.className}`}
			>
				<article
					className={headerClass}
					onClick={this.handleToggle}
					onKeyUp={this.handleKeyUpToggle}
					role="button"
					tabIndex="0"
				>
					<p>{this.state.value}</p>
					<AIcon type="arrowDown" />
				</article>
				{dropDown}
			</section>
		);
	}
}

ADropDown.propTypes = {
	id: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	placeholder: PropTypes.string,
	className: PropTypes.string,
	required: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
};

ADropDown.defaultProps = {
	placeholder: 'test',
	className: '',
	required: false,
	error: false,
	onChange: null,
};




// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.drop-down.js